import * as React from "react";
import Component from "../../AbstractComponent";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import TextField from "../../Partials/Material/TextField";
import Constants from "../../../Action/Constants";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
// import { Entity } from "Casadesk/Entity/Entity";


export class CoachPoaDialog extends Component {
  public state = {
    activeStep: 0,
    skipped: new Set(),
    openPoaCoachDialog: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    type: "",
    disableButtonDuringRequest: false,
    //company fields
    companyName: "",
    company: null,
    //person fields
    firstName: "",
    lastName: "",
    personDisplayName: "",
    person: null,
    firstNameError: false,
    defaultPoaCompanyName: "",
    companyNameError: false,
    errorFields: null,
    contactDetailType: "department",
    email: "",
    phone1: "",
    changeDefaultChoiseFlag: false,
    startCoachFlag: false,
    isFinishDialogOpen: false
    };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    this.setState({
      openPoaCoachDialog: this.props.openPoaCoachDialog,
      type: this.props.type,
      companyName: this.props.type === "company" ? this.props.defaultPoaCompanyName : "",
    });
	}

	public componentWillReceiveProps(nextProps) {
    this.setState({
      openPoaCoachDialog: nextProps.openPoaCoachDialog,
      type: nextProps.type,
      companyName: nextProps.type === "company" && (!this.state.startCoachFlag && !this.state.changeDefaultChoiseFlag) ? nextProps.defaultPoaCompanyName : this.state.companyName,
    });
  }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openPoaCoachDialog: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      type: "",
      disableButtonDuringRequest: false,
      //company fields
      companyName: "",
      company: null,
      //person fields
      firstName: "",
      lastName: "",
      personDisplayName: "",
      person: null,
      firstNameError: false,
      companyNameError: false,
      errorFields: null,
      contactDetailType: "department",
      email: "",
      phone1: "",
      changeDefaultChoiseFlag: false,
      startCoachFlag: false,
      isFinishDialogOpen: false
    });
  }

  public onClosePoaCoach = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();

    this.props.onClosePoaCoach.call(this);
    if(activeStep === steps.length - 1){
      this.props.setPoaCompanyFromCoach.call(this, this.state.company)
    }

    this.clearBackEndErrors();
    setTimeout(() => {this.clearState()}, 100);
  }


  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();

    if(activeStep === steps.length - 1) { // it is last step
      if(this.state.errorFields?.length > 0){
        this.setState({
          isFinishDialogOpen: true
        });
      } else {
        this.onClosePoaCoach();
      }
    } else {
      switch (activeStep) {
        case 0:
          return this.startStepFirst();
        case 1:
          return this.startStepSecond();
        case 2:
          return this.startStepThird();
        case 3:
          return this.plusOneStep();
      }
    }
  };

  public handleBack = () => {
    const { activeStep } = this.state;

    if(activeStep === 0) {
      if(typeof this.props.openFirstStep !== "undefined"){
        this.clearFieldsError();
        this.clearBackEndErrors();
        this.clearState();
        return this.props.openFirstStep.call(this);
      }
    } else {
      this.clearFieldsError();
      return this.setState({
        activeStep: activeStep - 1,
      });
    }
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    if(this.state.type === "company"){
      return [this.trans("coach/poaowner-scenario/company-step/first-title"), this.trans("coach/poaowner-scenario/company-step/second-title"), this.trans("coach/poaowner-scenario/company-step/third-title"), this.trans("coach/poaowner-scenario/company-step/fourth-title")];
    }
      // } else {
    //   return [this.trans("coach/propertyowner-scenario/person-step/second-title"),this.trans("coach/propertyowner-scenario/person-step/third-title"), this.trans("coach/propertyowner-scenario/person-step/fourth-title"), this.trans("coach/propertyowner-scenario/person-step/fifth-title")];
    // }
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step, "");
      case 1:
        return this.stepContent(step, "");
      case 2:
        return this.stepContent(step, "");
      case 3:
        return this.stepContent(step, "");
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step, subtitle) => {
    return (
      <div>
        <div>
          {this.sectionTitle(subtitle)}
        </div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
        {step === 2 && this.thirdStepDetails()}
        {step === 3 && this.fourthStepDetails()}
      </div>
    )
  }


  // Steppers components content
  public firstStepDetails = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStepFirst();
      case "person":
        // return this.personStepFirst();
    }
  }

  public secondStepDetails = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStepSecond();
      case "person":
        // return this.personStepSecond();
    }
  }



  public thirdStepDetails = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStepThird();
      case "person":
        // return this.personStepThird();
    }
  }

  public fourthStepDetails = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStepFourth();
      case "person":
        // return this.personStepFourth();
    }
  }


  //Components
  public companyStepFirst = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("coach/poaowner-scenario/company-step/first-info1")}
        </div>
        <div>
          <TextField
            autoComplete="off"
            className="form-element full-size"
            type="text"
            label={this.trans("coach/poaowner-scenario/company-step/first-field/poaname-label")}
            value={this.state.companyName}
            onChange={this.setCompanyName}
            autoFocus={true}
            variant="standard"
            error={this.state.companyNameError || this.getErrorFor("name")}
          />
          {!!this.getErrorFor("name") ? <div className="component-error-text">{this.getErrorFor("name")}</div> : this.state.companyNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}
        </div>
      </div>
    );
  }

  public companyStepSecond = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("coach/poaowner-scenario/company-step/second-info1")}
        </div>
        <div>
          <RadioGroup
            name="contactDetailChoice"
            className="filters-container"
            value={this.state.contactDetailType}
            onChange={this.chooseContactDetailType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/poaowner-radiobutton/person")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/poaowner-radiobutton/department")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="none"
              label={this.trans("coach/poaowner-radiobutton/none")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
          </RadioGroup>
        </div>
        <div>
          { this.state.contactDetailType === "person" &&
            <div>
                <TextField
                  autoComplete="off"
                  // id="firstName"
                  // name="firstName"
                  className="form-element full-size"
                  type="text"
                  label={this.trans("coach/propertyowner-scenario/person-step/second-field/firstname-label")}
                  value={this.state.firstName}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
                  autoFocus={true}
                  variant="standard"
                  error={this.state.firstNameError || this.getErrorFor("contacts.firstName")}
                />
                {!!this.getErrorFor("contacts.firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName")}</div> : this.state.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div> }

                <TextField
                  autoComplete="off"
                  // id="lastName"
                  // name="lastName"
                  className="form-element full-size"
                  type="text"
                  label={this.trans("coach/propertyowner-scenario/person-step/second-field/lastname-label") + this.trans("field/optional")}
                  value={this.state.lastName}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "lastName")}
                  variant="standard"
                  error={!!this.getErrorFor("lastName")}
                />
                {!!this.getErrorFor("lastName") && <div className="component-error-text">{this.getErrorFor("lastName")}</div>}

                <TextField
                  autoComplete="off"
                  className="form-element full-size"
                  label={this.trans("label-email") + this.trans("field/optional")}
                  value={this.state.email}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
                  variant="standard"
                  error={!!this.getErrorFor("email")}
                />
                {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}

                <div>
                  <TextField
                    autoComplete="off"
                    // id="phone1"
                    //name="phone1"
                    className="form-element full-size"
                    type="text"
                    label={this.trans("phone") + this.trans("field/optional")}
                    value={this.state.phone1}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
                    variant="standard"
                    error={!!this.getErrorFor("phone1")}
                  />
                  {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}
                </div>
              </div>
          }
          { this.state.contactDetailType === "department" &&
            <div>
              <TextField
                  autoComplete="off"
                  // id="firstName"
                  // name="firstName"
                  className="form-element full-size"
                  type="text"
                  label={this.trans("coach/poaowner-scenario/company-step/second-field/department-label")}
                  value={this.state.firstName}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
                  autoFocus={true}
                  variant="standard"
                  error={this.state.firstNameError || this.getErrorFor("contacts.firstName")}
                />
                {!!this.getErrorFor("contacts.firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName")}</div> : this.state.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

                <TextField
                  autoComplete="off"
                  className="form-element full-size"
                  label={this.trans("label-email") + this.trans("field/optional")}
                  value={this.state.email}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
                  variant="standard"
                  error={!!this.getErrorFor("email")}
                />
                {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}
                
                <div>
                  <TextField
                    autoComplete="off"
                    // id="phone1"
                    //name="phone1"
                    className="form-element full-size"
                    type="text"
                    label={this.trans("phone") + this.trans("field/optional")}
                    value={this.state.phone1}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
                    variant="standard"
                    error={!!this.getErrorFor("phone1")}
                  />
                  {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}
                </div>
            </div>
          }
        </div>
      </div>
    )
  }

  public companyStepThird = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("coach/poaowner-scenario/company-step/third-info1")}
        </div>
        <div>
          <ul>
            <li>{`${this.trans("coach/poaowner-scenario/company-step/third-poa/label")} ${this.state.companyName || ""}` }</li>
            {this.state.contactDetailType !== "none" && <li>{`${this.trans("coach/poaowner-scenario/company-step/third-contactdetails/label")} ${this.state.firstName}${this.state.lastName && ` ${this.state.lastName}`}${this.state.email && `, ${this.state.email}`}${this.state.phone1 && `, ${this.state.phone1}`}` }</li>}
          </ul>
        </div>
      </div>
    )
  }

  public companyStepFourth = () => {
    return (
      <div>
        {this.state.company ?
          <div>
            <div className="info-text">
              {this.trans("coach/poaowner-scenario/company-step/fourth-info1")}
            </div>
            <div className="success-created-entity-or-error">
              {this.state.company && this.state.company.name}
            </div>
          </div>
          :
          <div>
            <div className="info-text">
              {`${this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo1")}`}
            </div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map( item => {
                  let transField = this.trans(`coach-error-${item}`)

                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", {field: transField})}</div>
                })
              }
            </div>
            <div className="info-text">
              {this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo2")}
            </div>
          </div>
        }
      </div>
    );
  }

  // Reusebale title components

  public sectionTitle = (text) => {
    return(
      <div className="section-info-text">
        <div>{text}</div>
      </div>
    );
  }

  public sectionFieldTitle = (text) => {
    return(
      <div className="section-info-text">
        <h4>{text}</h4>
      </div>
    );
  }

  //Funcionality for steps
  //FIRST STEP LOGIC
  public startStepFirst = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStartStepFirst();
      case "person":
        // return this.personStartStepFirst();
    }
  }

  //SECOND STEP LOGIC
  public startStepSecond = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStartStepSecond();
      case "person":
        // return this.personStartStepSecond();
    }
  }

    //THIRD STEP LOGIC
    public startStepThird = () => {
      switch (this.state.type) {
        case "company":
          return this.companyStartStepThird();
        case "person":
          // return this.personStartStepThird();
      }
    }

  //Methods for step logic
  public companyStartStepFirst = () => {
    if(this.state.companyName === ""){
      this.setState({
        companyNameError: true
      })
    } else {
      this.plusOneStep();
    }
  }

  public companyStartStepSecond = () => {
    if(this.state.firstName === "" && this.state.contactDetailType !== "none") {
      this.setState({
        firstNameError: true
      })
    } else {
      this.setState({
        startCoachFlag: true
      })
      this.plusOneStep();
    }
  }

  public getPayloadForPerson = (): any => {
    let pageTemplate = "person";
    return {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      profession: "",
      email: this.state.email,
      phone1: this.state.phone1,
      phone2: "",
      contactRoleId: null,
      mainBankAccountId: "",
      companyId: null,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: pageTemplate,
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
    };
  }

  public personStartStepSecond = () => {
    if(this.state.companyName === ""){
      this.setState({
        companyNameError: true
      })
    } else {
      this.plusOneStep();
    }
  }

  public companyStartStepThird = () => {
    const pageTemplate = "company";
    this.saving(() => {
      this.setState({
        disableButtonDuringRequest: true
      })
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
        payload: {
          company: {
            name: this.state.companyName,
            email: "",
            phone: "",
            mainBankAccountId: "",
            address: null,
            amazonFolderName: "",
            note: "",
            pageTemplate: pageTemplate,
            contacts: this.state.contactDetailType === "none" ? undefined :
            {
              ...this.getPayloadForPerson()
            }
          }
        },
        onSuccess: (company) => {
          this.setState({
            company: company,
            disableButtonDuringRequest: false,
            errorFields: []
          })
          this.plusOneStep()
        },
        onError: (error) => {
          this.setState({
            disableButtonDuringRequest: false,
            errorFields: error.fields
          })
          this.plusOneStep()
        }
      });
    });
  }

  //Methods
  public setCompanyName = (event) => {
    this.setState({
      companyName: event.target.value
    })
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
    })
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }

  public chooseContactDetailType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      contactDetailType: choice,
      firstName: "",
      lastName: "",
      email: "",
      phone1: "",
      changeDefaultChoiseFlag: true
    },() => {
      this.clearFieldsError();
      this.clearBackEndErrors();
    });
  }

  public renderContent = () => {
    const steps = this.getSteps();
    const { activeStep } = this.state;
    let errorFieldsLength;
    if(this.state.errorFields) {
      errorFieldsLength = this.state.errorFields.length
    }
    return (
      <div className="stepper-wrapper">
        <div className="stepper-container">
        { activeStep !== steps.length &&
          <Stepper activeStep={activeStep}>
            {steps.map((label) => {
              const props = {};
              const labelProps = {};
              return (
                <Step key={label} {...props}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        }
        <div>
          <div className="step-content-wrapper">
            {this.getStepContent(activeStep)}
          </div>
        </div>
      </div>
      { activeStep !== steps.length &&
        <div className={`step-content-button-wrapper button-container ${activeStep === steps.length - 1 ? "without-cancel" : ""}`} >
          {activeStep !== steps.length - 1 &&
            <Button
              variant="contained"
              color="primary"
              onClick={this.onClosePoaCoach}
              className="cancel-button"
            >
            {this.trans("dialog-button/cancel")}
            </Button>
          }

          <div>
            { errorFieldsLength !== 0 && activeStep !== 0 &&
            <Button
              color="primary"
              variant="outlined"
              onClick={this.handleBack}
              disabled={this.state.disableButtonDuringRequest}
              className="back-button"
            >
              {this.trans("dialog-button/back")}
            </Button>
            }

            <Button
              variant="contained"
              color="primary"
              onClick={this.handleNext}
              disabled={this.state.disableButtonDuringRequest}
            >
            {activeStep === steps.length - 1 ? this.trans("dialog-button/close") : this.trans("coach/propertyowner-button/next")}
          </Button>
          </div>
        </div>
      }
    </div>
    )
  }

  public render() {
    return (
      <div>
        <Dialog
          className={`dialog dialog-window dialog-assistant coach-poa has-button-padding ${this.props.innerDialogClasses}`}
          open={this.state.openPoaCoachDialog}
          onClose={this.onClosePoaCoach}
          disableBackdropClick={true}
        >
          <DialogContent>
            {this.renderContent()}
          </DialogContent>
        </Dialog>

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isFinishDialogOpen}
          title={this.trans("title-attention") + "!"}
          content={this.trans("coach-loseinformation/info")}
          positiveButtonLabel={this.trans("dialog-button/continue")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => this.setState({ isFinishDialogOpen: false }, this.onClosePoaCoach)}
          onDiscard={() => this.setState({ isFinishDialogOpen: false, considerPaidProcess: false }) }
        />
      </div>
    );
  }
}
